import * as React from 'react';
import { classNames } from '@progress/kendo-react-common';
var ListViewFooter = function (props) {
    return (React.createElement("div", { className: classNames('k-listview-footer', props.className), style: props.style }, props.children));
};
export default ListViewFooter;
//# sourceMappingURL=ListViewFooter.js.map